/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * webVitals.ts — we\1 \2itals (services/operator-web-app).
 */

/**
 * E7-S1: Web Vitals reporting (CLS, INP, LCP, FCP, TTFB).
 * Reports to metrics collector for dashboard / optional backend.
 */

import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';
import { getMetricsCollector } from './metrics';

function reportToMetrics(metric: { name: string; value: number }) {
  const name = metric.name.toLowerCase();
  const collector = getMetricsCollector();
  if (name === 'cls') collector.reportWebVital('cls', metric.value);
  else if (name === 'fcp') collector.reportWebVital('fcp', metric.value);
  else if (name === 'inp') collector.reportWebVital('inp', metric.value);
  else if (name === 'lcp') collector.reportWebVital('lcp', metric.value);
  else if (name === 'ttfb') collector.reportWebVital('ttfb', metric.value);
}

export function initWebVitals(): void {
  onCLS(reportToMetrics);
  onFCP(reportToMetrics);
  onINP(reportToMetrics);
  onLCP(reportToMetrics);
  onTTFB(reportToMetrics);
}
